function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.148 1.496L4.895 4.75l3.253 3.254-.82.82L4.074 5.57.82 8.824 0 8.004 3.254 4.75 0 1.496l.82-.82L4.074 3.93 7.328.676l.82.82z"
});

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    fill: "none"
  }, props), _ref);
}

export default SvgClose;